import { Bounds } from "../../../utilities/BoundsObserver/Bounds";

/**
 * Gets the adjusted bounds of the overlay element.
 * @param overlayBounds The current expected overlay bounds.
 * @param containerBounds The container bounds.
 * @param adjustment The adjustment method.
 * @returns The adjusted bounds to be applied to the overlay element.
 */
export function getAdjustedOverlayBounds(
  overlayBounds: Bounds,
  containerBounds: Bounds,
  adjustment: "horizontal" | "vertical" | "both" | "none",
): Bounds {
  let { top, left } = overlayBounds;
  const { width, height } = overlayBounds;

  if (left < containerBounds.left) left = containerBounds.left;
  if (top < containerBounds.top) top = containerBounds.top;

  const overlayRight = left + width;
  const overlayBottom = top + height;
  const containerRight = containerBounds.left + containerBounds.width;
  const containerBottom = containerBounds.top + containerBounds.height;

  if (adjustment === "horizontal" || adjustment === "both") {
    if (overlayRight > containerRight) {
      left -= overlayRight - containerRight;
    }
  }

  if (adjustment === "vertical" || adjustment === "both") {
    if (overlayBottom > containerBottom) {
      top -= overlayBottom - containerBottom;
    }
  }

  return {
    top,
    left,
    width,
    height,
  };
}
